// extracted by mini-css-extract-plugin
module.exports = {"container":"_54637ac","arrow":"_8585b6d"};